module.exports = __webpack_public_path__ + "img/pw-logo.eeef4429.png";